import Vue from 'vue'
import 'ant-design-vue/dist/antd.css'
import {
  Tree
} from 'ant-design-vue'

Vue.use(Tree)
